import React from 'react';
import { Grid, Segment, Label, Button } from 'semantic-ui-react';
import { toIDR } from '../../../../../_utils/tocurrency';

export default class RincianList extends React.Component {

   removeRinc(item, i) {
      this.props.removeRinc(item, i);
   }

   editRinc(item, i) {
      this.props.edit(item, i);
   }

   render() {
      return(
         <Grid>
            <Grid.Column>
               <Segment.Group>
                  {this.props.rincian.map((item, i)=>(
                     <Segment key={i} secondary={i%2===0}>
                        <Button.Group size='mini' floated='right'>
                           <Button color='green' icon='pencil' onClick={()=>{this.editRinc(item, i)}}/>
                           <Button color='red' icon='trash' onClick={()=>{this.removeRinc(item, i)}} />
                           
                        </Button.Group>   
                        
                        {i+1}.&nbsp;&nbsp;<Label circular color="teal">
                           4.{item.kd_rek_2}.{item.kd_rek_3}.{item.kd_rek_4}.{item.kd_rek_5}.{item.kd_rek_6}&nbsp;&nbsp;
                        </Label>
                        <Label circular color="violet">
                           {toIDR(item.nilai)}
                        </Label>
                     </Segment>
                  ))}
               </Segment.Group>
            </Grid.Column>
         </Grid>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/opd/_sts/RincianList.js